import { render } from "./OlvidoClave.vue?vue&type=template&id=45578e87&scoped=true"
import script from "./OlvidoClave.vue?vue&type=script&lang=js"
export * from "./OlvidoClave.vue?vue&type=script&lang=js"

import "./OlvidoClave.vue?vue&type=style&index=0&id=45578e87&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45578e87"]])

export default __exports__